<template>
	<b-container fluid class="mt-2">

    <div class="bg-light-form text-center">
      <h1>Not implemented</h1>
      New features coming soon
    </div>

		<b-form>
			<b-row>
				<b-col xl="4" md="4" sm="12">
					<div class="mt-2">
						<label for="period" class="font-weight-900 text-sm">Period:</label>
						<b-form-select
							id="period"
							v-model="diameterReportForm.period"
							:options="periodOption"
							value-field="key"
							text-field="value"
							@change="getSelectedDate(diameterReportForm.period)"
						></b-form-select>
					</div>
				</b-col>
				<b-col xl="4" md="4">
					<div class="mt-2" v-if="selectDayStatus">
						<label for="selectDay" class="form-control-label font-weight-900">Day:</label>
						<base-input
							type="date"
							v-model="diameterReportForm.dynamicDate"
							id="selectDay"
							@change="selectDate()"
						/>
					</div>

					<div class="mt-2" v-if="selectWeekStatus">
						<label for="selectWeek" class="form-control-label font-weight-900">Week:</label>
						<base-input
							type="week"
							v-model="diameterReportForm.dynamicDate"
							id="selectWeek"
							@change="selectWeek()"
						/>
					</div>

					<div class="mt-2" v-if="selectMonthStatus">
						<label for="selectMonth" class="form-control-label font-weight-900">Month:</label>
						<b-form-select
							id="selectMonth"
							v-model="diameterReportForm.dynamicDate"
							:options="monthOption"
							value-field="key"
							text-field="value"
							@change="selectMonth()"
						></b-form-select>
					</div>
				</b-col>
				<b-col xl="4" md="4" sm="12">
					<div class="mt-2 text-left">
						<label class="form-control-label font-weight-900 text-white">Generate Report</label><br />
						<base-button type="primary" title="Search"  v-on:click="generateReport" :loading="submitLoading">
							Generate Report
						</base-button>
					</div>
				</b-col>
			</b-row>
		</b-form>
		<hr />
		<transition name="slide-fade" v-if="diameterReportDisplayStatus">
			<div>
				<div class="text-center w-100">
					<b-icon
						icon="three-dots"
						class="text-center"
						animation="cylon"
						font-scale="4"
						v-if="loadingStatus"
					></b-icon>
				</div>

				<div class="mb-3" v-if="!loadingStatus">
					<b-row>
						<b-col cols="12" xl="4" lg="4" md="4" sm="4">
							<b-form-group
								label=""
								label-for="per-page-select"
								label-cols-sm="0"
								label-cols-md="0"
								label-cols-lg="0"
								label-align-sm="center"
								label-size="sm"
								class="mb-2 per-page-select"
							>
							<label for="per-page-select" class="mr-2 text-sm mt-1 mr-4">Show</label>
							<b-form-select
								id="per-page-select"
								class="diameter-report-select"
								v-model="perPage"
								:options="pageOptions"
								size="sm"
								v-on:input="changePageOption(perPage)"
							></b-form-select>
							</b-form-group>
						</b-col>
						<b-col cols="12" xl="4" lg="3" md="3" sm="3" class="text-center">
							<b-button-group class="mb-2">
								<b-button
									size="md"
									class="cursor-pointer d-none"
									v-b-tooltip.hover
									title="Copy"
									v-clipboard:copy="JSON.stringify(tableData)"
									v-clipboard:success="tableDataCopy"
									v-clipboard:error="copiedError"
									id="popover-button-event"
								>
									<b-popover
										triggers="click"
										ref="popover"
										target="popover-button-event"
										title="Copy to clipboard"
										:content="popOverContent"
									></b-popover>
									<i class="far fa-copy text-green"></i>
								</b-button>
								<download-excel :data="tableData" :name="exportDataTitle">
									<b-button size="md" class="cursor-pointer usage-graphing-button" v-b-tooltip.hover title="Excel" >
										<i class="far fa-file-excel text-primary"></i>
									</b-button>
								</download-excel>
								<vue-json-to-csv :json-data="tableData" :csv-title="exportDataTitle">
									<b-button size="md" class="cursor-pointer usage-graphing-button ml-3" v-b-tooltip.hover title="CSV">
										<i class="far fa-file-alt text-orange"></i>
									</b-button>
								</vue-json-to-csv>
								<b-button
									size="md"
									class="cursor-pointer d-none"
									v-b-tooltip.hover
									title="PDF"
									v-on:click="generatePDF()"
								>
									<i class="far fa-file-pdf text-dark"></i>
								</b-button>
							</b-button-group>
						</b-col>
						<b-col cols="12" xl="4" lg="5" md="5" sm="5" class="customer-table-select">
							<b-form-group
								label=""
								label-for="filter-input"
								label-align-sm="right"
								label-size="sm "
								class="mb-0 per-page-select"
							>
								<label for="filter-input" class="text-sm mr-2 mt-1">Search:</label>
								<b-input-group size="sm">
									<b-form-input id="filter-input2" v-model="filter" class="mb-4"></b-form-input>
								</b-input-group>
							</b-form-group>
						</b-col>
					</b-row>


					<div>
						<b-row class="mb-3">
							<b-col xl="12">
								<p class="h4">Report : Diameter Report</p>
								<p class="h4">Customer : {{ customer }}</p>
								<p class="h4">Period : {{ displayPeriod }}</p>
							</b-col>
						</b-row>
						<div class="">
							<b-table
								striped
								hover
								:items="tableData"
								:fields="tableColumns"
								:current-page="currentPage"
								:per-page="perPage"
								:filter="filter"
								:filter-included-fields="filterOn"
								:sort-by.sync="sortBy"
								:sort-desc.sync="sortDesc"
								:sort-direction="sortDirection"
								head-variant="light"
								table-class="text-nowrap"
								class="data-management-table primary-table"
								sticky-header="true"
								thead-class="white"
								show-empty
								responsive
								small
							>
								<template #cell(app_id)="row">
									<span v-if="!row.detailsShowing" @click="row.toggleDetails" class="cursor-pointer">
										<i class="fa fa-plus-circle text-primary"></i> {{ row.value }}
									</span>
									<span v-if="row.detailsShowing" @click="row.toggleDetails" class="cursor-pointer">
										<i class="fa fa-minus-circle text-danger"></i> {{ row.value }}
									</span>
								</template>

								<template #row-details="row">
									<div class="text-left">
										<span class="h4 font-weight-700 mr-3">timestamp</span>
										<span>{{ row.item.timestamp }}</span>
									</div>
								</template>
							</b-table>
						</div>

						<b-row class="mt-4">
							<b-col >
								<p class="ml-3 nowrap">{{ startPage() }} - {{ lastPage() }} of {{ totalRows }}</p>
							</b-col>
							<b-col >
								<b-pagination
									class="flex-fill-custom pr-4 ml-3 justify-content-end"
									v-model="currentPage"
									:total-rows="totalRows"
									:per-page="perPage"
									size="sm"
								></b-pagination>
							</b-col>
						</b-row>
					</div>
				</div>
			</div>
		</transition>
	</b-container>
</template>

<script>
import moment from "moment";
import configDirective from "../../../../common/directive/config-directive";
import diameterService from "../../../../common/api-services/diameter-service";
import VueJsonToCsv from "vue-json-to-csv";
import downloadExcel from "vue-json-excel";
import jsPDF from "jspdf";
import pagination from '../../../../common/format/pagination'

export default {
	name: "Diameter-Report",
	components: {
		VueJsonToCsv,
		downloadExcel,
	},
	data() {
		return {
			diameterReportForm: {
				period: "daily",
				dynamicDate: "",
			},
			periodOption: [
				{key: "daily", value: "Daily"},
				{key: "weekly", value: "Weekly"},
				{key: "monthly", value: "Monthly"},
			],
			loadingStatus: false,
			selectDayStatus: false,
			selectWeekStatus: false,
			selectMonthStatus: false,
			totalRows: 0,
			currentPage: 1,
			pageOptions: [10, 25, 50, 100],
			perPage: 10,
			tableColumns: [
				{key: "app_id", value: "application", sortable: true, sortDirection: "desc"},
				{key: "command_id", value: "command", sortable: true, sortDirection: "desc"},
				{key: "customer", value: "customer", sortable: true, sortDirection: "desc"},
				{key: "imsi", value: "imsi", sortable: true, sortDirection: "desc"},
				{key: "type", value: "type", sortable: true, sortDirection: "desc"},
				{key: "orealm_req", value: "realm", sortable: true, sortDirection: "desc"},
				{key: "message_count", value: "message_count", sortable: true, sortDirection: "desc"},
			],
			tableData: [],
			sortBy: "",
			sortDesc: false,
			sortDirection: "asc",
			filter: null,
			filterOn: [],
			loadingNum: 1,
			selectedDateFrom: "",
			selectedDateTo: "",
			timeSeries: "1h",
			displayPeriod: "",
			monthOption: [],
			exportDataTitle: "Customer Portal  Diameter Usage Graphing",
			copiedMessage: "",
			copiedError: "",
			popOverContent: "",
			customer: "",
			diameterReportDisplayStatus: false,
			submitLoading: false,
		};
	},
	mounted() {
		this.getSelectedDate(this.diameterReportForm.period);
		// this.customer = process.env.VUE_APP_CLIENT;
		this.customer = process.env.VUE_APP_CLIENT.toUpperCase();
	},
	methods: {
		getTotalRows() {
			if (this.perPage > this.totalRows) {
				this.fromPage = this.totalRows;
			} else {
				this.fromPage = this.perPage;
			}
		},
		startPage() {
		   return pagination.startPageFunc(this.currentPage, this.perPage)
		},
		lastPage() {
			return pagination.lastPageFunc(this.currentPage, this.perPage, this.totalRows)
		},

		getSelectedDate(option) {
			switch (option) {
				case "daily": {
					this.selectDayStatus = true;
					this.selectWeekStatus = false;
					this.selectMonthStatus = false;
					this.getCurrentDate();
					break;
				}
				case "weekly": {
					this.selectWeekStatus = true;
					this.selectDayStatus = false;
					this.selectMonthStatus = false;
					this.getCurrentWeek();
					break;
				}
				case "monthly": {
					this.selectMonthStatus = true;
					this.selectDayStatus = false;
					this.selectWeekStatus = false;
					this.getCurrentMonth();
					break;
				}
				default:
					break;
			}
		},

		getCurrentDate() {
			let date = new Date();
			let thisYear = date.getFullYear();
			let thisDate = date.getDate();
			let thisMonth = date.getMonth() + 1;
			if (thisDate < 10) {
				thisDate = "0" + thisDate;
			}
			if (thisMonth < 10) {
				thisMonth = "0" + thisMonth;
			}
			this.diameterReportForm.dynamicDate = thisYear + "-" + thisMonth + "-" + thisDate;
			this.selectDate();
		},

		getCurrentWeek() {
			let today = new Date();
			let year = today.getFullYear();
			let oneJan = new Date(year, 0, 1);
			let numberOfDays = Math.floor((today - oneJan) / (24 * 60 * 60 * 1000));
			let result = Math.floor((today.getDay() + 1 + numberOfDays) / 7);
			this.diameterReportForm.dynamicDate = year + "-W" + result;
			this.selectWeek();
		},

		getCurrentMonth() {
			this.monthOption = [];
			this.monthOption.push({
				key: "empty",
				value: "Select One",
			});
			let monthNames = [
				"January",
				"February",
				"March",
				"April",
				"May",
				"June",
				"July",
				"August",
				"September",
				"October",
				"November",
				"December",
			];
			let today = new Date();
			let year = today.getFullYear();
			let month = today.getMonth() + 1;
			let i = 0;
			do {
				let key = (month > 9 ? "" : "0") + month + "/01/" + year;
				let value = monthNames[month - 1] + " " + year;
				this.monthOption.push({
					key: key,
					value: value,
				});
				if (month - 1 < 1) {
					month = 13;
				}
				if (month === 0) {
					month = 11;
					year--;
				} else {
					month--;
				}
				i++;
			} while (i < 3);
			this.diameterReportForm.dynamicDate = "empty";
			this.selectMonth();
		},

		selectDate() {
			this.selectedDateFrom =
				moment(new Date(this.diameterReportForm.dynamicDate)).format("YYYY-MM-DDT00:00:00") + "Z";
			this.selectedDateTo =
				moment(new Date(this.diameterReportForm.dynamicDate)).format("YYYY-MM-DDT23:59:00") + "Z";
			this.timeSeries = "1d";
			this.displayPeriod = this.diameterReportForm.dynamicDate;
		},

		selectWeek() {
			let weekNum = this.diameterReportForm.dynamicDate.split("W")[1];
			let year = this.diameterReportForm.dynamicDate.split("-")[0].trim();
			let d = 1 + weekNum * 7;
			let newDate = new Date(Number(year), 0, d);

			let first = newDate.getDate() - newDate.getDay();
			let last = first + 6;
			let firstDay = new Date(newDate.setDate(first));
			let lastDay = new Date(newDate.setDate(last));

			if (first < 0) {
				lastDay = new Date(lastDay.getFullYear(), lastDay.getMonth() + 1, lastDay.getDate());
			}

			this.selectedDateFrom = moment(new Date(firstDay)).format("YYYY-MM-DDT00:00:00") + "Z";
			this.selectedDateTo = moment(new Date(lastDay)).format("YYYY-MM-DDT23:59:00") + "Z";
			this.timeSeries = "1d";
			this.displayPeriod = this.selectedDateFrom + " - " + this.selectedDateTo;
		},

		selectMonth() {
			let date = new Date(this.diameterReportForm.dynamicDate);
			let y = date.getFullYear();
			let m = date.getMonth();
			let firstDay = moment(new Date(y, m, 1)).format("YYYY-MM-DDT00:00:00") + "Z";
			let lastDay = moment(new Date(y, m + 1, 0)).format("YYYY-MM-DDT23:59:00") + "Z";
			this.selectedDateFrom = firstDay;
			this.selectedDateTo = lastDay;
			this.timeSeries = new Date(y, m + 1, 0).getDate() + "d";
			let displayMonth = this.monthOption.find(item => item.key === this.diameterReportForm.dynamicDate).value;
			if (displayMonth === "Select One") {
				this.displayPeriod = "";
			} else {
				this.displayPeriod = displayMonth;
			}
		},

		generateReport() {
			if (this.diameterReportForm.period === "monthly" && this.diameterReportForm.dynamicDate === "empty") {
				this.$toast.error('Error - Please select valid reporting period')
				return false;
			}

			this.diameterReportDisplayStatus = true;
			this.loadingStatus = true;
			let url = configDirective.getInfluxSettingsUrl();
			let db = configDirective.getInfluxSettingsDB();
			let configCustomer = configDirective.getInfluxSettingCustomer();

			let customerCondition = " AND customer = '" + configCustomer + "' AND imsi !='0' ";
			if (customerCondition === "PORTAL_ADMIN") {
				customerCondition = " AND imsi =~ /" + this.diameterGraphForm.customer + "*/  ";
			}
			let query =
				'SELECT count("message_count") AS message_count ' +
				"FROM diameter_usage " +
				"WHERE time >= '" +
				this.selectedDateFrom +
				"' " +
				" AND time <= '" +
				this.selectedDateTo +
				"' " +
				customerCondition +
				"GROUP BY time(" +
				this.timeSeries +
				"), imsi, customer, type, app_id,command_id,orealm_req";

			let apiURL = url + "?db=" + db + "&pretty=true&q=" + query;
			this.submitLoading = true;
			diameterService.getUpdateGraph(apiURL).then(res => {
				this.submitLoading = false;
				try {
					this.loadingStatus = false;
					let data = res[0].series;
					if (data && data.length > 0) {
						data.map(item => {
							let _childItem = {
								app_id: item.tags.app_id,
								command_id: item.tags.command_id,
								customer: item.tags.customer,
								imsi: item.tags.imsi,
								type: item.tags.type,
								orealm_req: item.tags.orealm_req,
								message_count: item.values[0][1],
								timestamp: item.values[0][0],
							};
							this.tableData.push(_childItem);
						});
					}
					this.totalRows = this.tableData.length;
					this.getTotalRows()
				} catch (e) {
					this.$toast.error(e.message)
				}
			});
		},

		tableDataCopy() {
			this.popOverContent = "Copied " + this.totalRows + " rows to clipboard";
			setTimeout(() => {
				this.$refs.popover.$emit("close");
			}, 2000);
		},

		generatePDF() {
			let doc = new jsPDF();
			doc.text(JSON.stringify(this.tableData), 10, 10);
			doc.save(this.exportDataTitle + ".pdf");
		},
	},
};
</script>
